var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2655 3.84668H10.9322C10.0482 3.84668 9.20031 4.19787 8.57519 4.82299C7.95007 5.44811 7.59888 6.29596 7.59888 7.18001V33.8467C7.59888 35.6967 9.08221 37.18 10.9322 37.18H30.9322C32.7822 37.18 34.2655 35.6967 34.2655 33.8467V13.8467L24.2655 3.84668ZM30.9322 33.8467H10.9322V7.18001H22.5989V15.5133H30.9322V33.8467ZM16.8322 26.5967L20.3155 30.08L18.1822 32.18L12.5989 26.5967L18.1822 21.0133L20.3155 23.1133L16.8322 26.5967ZM29.2655 26.5967L23.6822 32.18L21.5655 30.08L25.0489 26.5967L21.5655 23.1133L23.6822 21.0133L29.2655 26.5967Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImg3);
export default __webpack_public_path__ + "static/media/fileImg3.e6ca4b88d534171cbb1d110119881949.svg";
export { ForwardRef as ReactComponent };